import axios from 'axios';
import * as utils from '../../../utils/Utils';
import { getApiRoot, getNonGwApiRoot } from '../../../constants/ParamountReactConstants';

const CancelToken = axios.CancelToken;

export const fetchExportBuilderAdvancedTemplates = (brandId?: number) => {
  const params = utils.createURL([{ name: 'brand_id', values: brandId }]);

  return {
    type: 'FETCH_EXPORT_BUILDER_ADVANCED_TEMPLATES',
    payload: axios.get(`${getApiRoot()}/full_export_templates${params}`),
  };
};

let columnCancelToken: any;

export const fetchExportBuilderAdvancedColumns = (
  templateId: number,
  brandId?: number,
  sheetId?: number,
  excludeSheets?: boolean
) => {
  if (columnCancelToken) columnCancelToken();

  const urlParams = [
    { name: 'brand_id', values: brandId },
    { name: 'sheet_id', values: sheetId },
    { name: 'exclude_sheets', values: excludeSheets ? ('true' as any) : undefined },
  ];

  const params = utils.createURL(urlParams);

  return {
    type: 'FETCH_EXPORT_BUILDER_ADVANCED_COLUMS',
    payload: axios.get(`${getApiRoot()}/full_export_templates/${templateId}/columns${params}`, {
      cancelToken: new CancelToken(c => (columnCancelToken = c)),
    }),
    meta: { templateId, sheetId },
  };
};

export const fetchExportBuilderAdvancedSheets = (templateId: number) => {
  return {
    type: 'FETCH_EXPORT_BUILDER_ADVANCED_SHEETS',
    payload: axios.get(`${getApiRoot()}/full_export_templates/${templateId}/sheets`),
    meta: { templateId },
  };
};

export const fetchExportBuilderAdvancedSegments = (brandId?: number) => {
  const params = utils.createURL([{ name: 'brand_id', values: brandId }]);

  return {
    type: 'FETCH_EXPORT_BUILDER_ADVANCED_SEGMENTS',
    payload: axios.get(`${getNonGwApiRoot()}/full_export_templates/segments${params}`),
  };
};

const segmentCancelTokens: any[] = [];

export const fetchExportBuilderAdvancedSegment = (brandId: number, segmentId: number) => {
  if (segmentCancelTokens[segmentId]) segmentCancelTokens[segmentId]();

  const params = utils.createURL([
    { name: 'brand_id', values: brandId },
    { name: 'segment_ids', values: segmentId },
  ]);

  return {
    type: 'FETCH_EXPORT_BUILDER_ADVANCED_SEGMENT',
    payload: axios.get(`${getNonGwApiRoot()}/full_export_templates/segments${params}`, {
      cancelToken: new CancelToken(c => {
        segmentCancelTokens[segmentId] = c;
      }),
    }),
    meta: { segmentId },
  };
};

let previewCancelToken: any;

export const fetchExportBuilderAdvancedPreview = (
  templateId: number,
  brandId?: number,
  sheetId?: number,
  sheetIndex?: number
) => {
  if (previewCancelToken) previewCancelToken();

  const urlParams = [
    { name: 'brand_id', values: brandId },
    { name: 'sheet_id', values: sheetId },
    { name: 'sheet_index', values: sheetIndex },
  ];

  const params = utils.createURL(urlParams);

  return {
    type: 'FETCH_EXPORT_BUILDER_ADVANCED_PREVIEW',
    payload: axios.get(
      `${getNonGwApiRoot()}/full_export_templates/${templateId}/preview${params}`,
      {
        cancelToken: new CancelToken(c => (previewCancelToken = c)),
      }
    ),
    meta: { templateId, sheetId, sheetIndex },
  };
};
